// extracted by mini-css-extract-plugin
export default {"accordion":"_9D0t","item":"_6hOR","trigger":"_2qz7","zebra":"_2Cx5","noneBorder":"_1pg7"};